module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "white-background-hack"
  }, [_c('HomeDirect')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3be19cfc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CelladorAlesSyndicate.vue
// module id = 372
// module chunks = 1